/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindCodeExchangeResVo
 */
export interface OAuthBindCodeExchangeResVo {
    /**
     * 后续发验证码和绑定接口使用的绑定凭证
     * OAuth绑定凭证，仅响应体返回
     * @type {string}
     * @memberof OAuthBindCodeExchangeResVo
     */
    oauthBindToken?: string;
}

/**
 * Check if a given object implements the OAuthBindCodeExchangeResVo interface.
 */
export function instanceOfOAuthBindCodeExchangeResVo(value: object): value is OAuthBindCodeExchangeResVo {
    return true;
}

export function OAuthBindCodeExchangeResVoFromJSON(json: any): OAuthBindCodeExchangeResVo {
    return OAuthBindCodeExchangeResVoFromJSONTyped(json, false);
}

export function OAuthBindCodeExchangeResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindCodeExchangeResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'oauthBindToken': json['oauthBindToken'] == null ? undefined : json['oauthBindToken'],
    };
}

export function OAuthBindCodeExchangeResVoToJSON(json: any): OAuthBindCodeExchangeResVo {
    return OAuthBindCodeExchangeResVoToJSONTyped(json, false);
}

export function OAuthBindCodeExchangeResVoToJSONTyped(value?: OAuthBindCodeExchangeResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oauthBindToken': value['oauthBindToken'],
    };
}

